class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.cartForm = this.closest('cart-form');
  }

  connectedCallback() {
    if (this.cartForm) {
      this.observeCartFormChanges();
    }
    this.initOptions();
  }

  initOptions() {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(option => {
      option.addEventListener('click', () => this.selectOption(option));
    });
  }

  selectOption(option) {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(opt => opt.classList.remove('selected-plan'));
    option.classList.add('selected-plan');
    this.updateFormData(option);
  }

  updateFormData(option) {
    if (this.cartForm) {
      const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
      const items = Object.values(dataForm.items);
      const targetItem = items[0];

      if (targetItem) {
        const payload = {
          id: targetItem.id,
          quantity: targetItem.quantity,
          ...(option.getAttribute('data-plan-id') && {
            selling_plan: option.getAttribute('data-plan-id'),
          }),
          properties: {},
        };

        this.cartForm?.formDataAPI?.updateItems(payload);
      }
    }
  }

  observeCartFormChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
          this.handleCartFormUpdate();
        }
      }
    });

    observer.observe(this.cartForm.querySelector("#product-card-section"), { attributes: true, attributeFilter: ['data-product-card-selected_variant_id'] });

    window.addEventListener('beforeunload', () => observer.disconnect());
  }

  handleCartFormUpdate() {
    const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
    const variantId = Object.values(dataForm.items)?.[0]?.id;

    if (variantId) {
      this.classList.add("loading-plans");
      fetch(`${window.location.pathname}?variant=${variantId}`)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch updated section');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          const newContent = newDocument.querySelector('subs-widget');

          if (newContent) {
            this.replaceWith(newContent);
          }
        })
        .catch(error => {
          console.error('Error updating section:', error);
        });
    }
  }
}

customElements.define('subs-widget', SubscriptionWidget);